import React, { useMemo } from "react";
import { Ptag } from "../fonts";
import { Radio, Reupload, Divider } from "./styles";
import { Icons } from "..";
import { theme } from "theme";

const UploadedSection = ({ text, isSelected, onSelect }) => {
  
  const selectionIcon = useMemo(() => {
    if (isSelected) {
      return "#436AB2";}
    return "#f9fcff";
  }, [isSelected]);
  return (
    <div style={{height: "170px"}}>
      <Ptag fontWeight="600" fontSize="20px"  marginBottom="10px" color="#4a4a4a" style={{"paddingLeft":"2rem"}}>{text[0]}</Ptag>
      <Divider/>
      <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", marginLeft:"2rem"}}>
        <div style={{display:"flex", flexDirection:"row",gap:"2rem"}}>
          <Reupload>
              <Ptag fontWeight="600" fontSize="16px" textAlign = "center" color= "#4a4a4a">{text[1]}</Ptag>
              {/* <Icons style={{ 'marginRight': '10px'}} icon='cross' fill="#7e7b7f" /> */}
          </Reupload>
          <Reupload>
              <Ptag fontWeight="600" fontSize="16px" textAlign = "center" color= "#4a4a4a">{text[2]}</Ptag>
              {/* <Icons style={{ 'marginRight': '10px' }} icon='cross' fill="#7e7b7f" /> */}
          </Reupload>
        </div>
        <Radio onClick={onSelect} backgroundColour={theme.accentColor}>
            <Icons style={{ 'marginRight': '10px' }} icon='upload' fill="#F9FCFF" />
            <Ptag fontWeight="600" fontSize="16px" textAlign = "center" color= "#F9FCFF">Upload Again</Ptag>
        </Radio>
      </div>
    </div>
  );
};

export default UploadedSection;
